import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigationType } from "react-router-dom";
import { logout } from "../../redux/actions/authActions";
import { persistor } from "../../redux/store";

const SESSION_EXIT_PATHS = new Set(["/", "/home", "/login"]);

const isAuthenticated = (auth) =>
  Boolean(auth?.role && auth?.loginStatus === "SUCCESS");

const AuthSessionGuard = () => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const authenticated = isAuthenticated(auth);

  useEffect(() => {
    if (
      navigationType !== "POP" ||
      !authenticated ||
      !SESSION_EXIT_PATHS.has(location.pathname)
    ) {
      return;
    }

    dispatch(logout());
    persistor.purge();
  }, [authenticated, location.pathname, navigationType, dispatch]);

  return null;
};

export default AuthSessionGuard;
